<template>
  <v-container class="container">
    <v-form ref="formDevice" v-model="valid" lazy-validation>
      <div style="padding-top: 55px;"></div>
      <div v-if="searched" style="height: 100%; overflow-y: scroll;">
        <GmapMap ref="gmap"
                 :center="this.mapView"
                 :zoom="17"
                 map-type-id="roadmap"
                 :options="{
                                    scaleControl: true,
                                    mapTypeControl: true,
                                    zoomControl: true,
                                    scrollwheel: true,
                                    keyboardShortcuts: false,
                                    gestureHandling: 'greedy'
                                  }"
                 style="width: 100%; height: 60vh"
        >

            <GmapMarker
                id="marker11"
                :key="index"
                v-for="(m, index) in markers"
                :position="m.position"
                :clickable="true"
                :icon="m.icon"
                :options="{ strokeColor:m.colorLine}"

            />
          <GmapMarker
              :key="m.id"
              v-for="(m) in markerStops"
              :position="m.position"
              :clickable="true"
              @mousedown="selectMarker(m)"
              :icon="m.icon"
              id="img2"
          />

          <GmapMarker :key="m.id" v-for="(m) in markerStart" :position="m.position" :clickable="true"
          @click="selectMarker(m)" :icon="customIconGreen" />

          <GmapMarker :key="m.id" v-for="(m) in markerEnd" :position="m.position" :clickable="true"
            @click="selectMarker(m)" :icon="customIconRed" />

          <gmap-polyline :key="m.id"
                         v-for="(m) in path"
                         :path="m.position"
                         :options="{ strokeColor:m.colorLine}"
          />
          <gmap-info-window v-if="markerStop"
                            @closeclick="windowOpen=false"
                            :opened="windowOpen"
                            :position="markerStop.position"
                            :options="{
                                      pixelOffset: {
                                        width: 0,
                                        height: -35
                                      }
                                    }"
          >
            <button @click="windowOpen=false" style="float: right; font-size: 24px;"><strong>X</strong></button>
            <p><strong>Datos de dispositivo detenido</strong></p>
            <p v-if="markerStop.data.startTime"><strong>Inicio:</strong> {{formatDateMinus(markerStop.data.startTime)}}</p>
            <p v-if="markerStop.data.endTime"><strong>Fin:</strong> {{formatDateMinus(markerStop.data.endTime)}}</p>
            <p v-if="markerStop.data.duration"><strong>Tiempo:</strong> {{$store.getters.msToTime(markerStop.data.duration)}}</p>
            <p><strong>Latitud:</strong> {{Number(markerStop.data.latitude.toFixed(5))}}</p>
            <p><strong>Longitud:</strong> {{Number(markerStop.data.longitude.toFixed(5))}}</p>
            <p><strong>Dirección:</strong> {{this.direction}}</p>
          </gmap-info-window>
        </GmapMap>
        <div style="z-index: 1000 !important;">
          <v-layout>
            <v-flex xs12 sm8 offset-sm1>
              <v-slider
                  v-model="increment"
                  :max="listReportTracking.length"
                  :min="0"
                  :step="1"
                  style="margin-left: 10px; margin-right: 5px"
                  @change="playTrack"
              ></v-slider>
              <div align="center">
                <v-btn
                    v-if="buttonTrack=='PLAY'"
                    fab dark
                    small @click="createInterval"
                    slot="activator"
                    color="primary">
                  <v-icon dark>play_arrow</v-icon>
                </v-btn>
                <v-btn
                    v-if="buttonTrack=='PAUSE'"
                    fab dark
                    small @click="pauseInterval"
                    slot="activator"
                    color="primary">
                  <v-icon dark>pause</v-icon>
                </v-btn>
                <v-btn
                    fab dark
                    small @click="stopInterval"
                    slot="activator"
                    color="primary">
                  <v-icon dark>stop</v-icon>
                </v-btn>

                <v-btn
                    fab dark
                    small @click="changeInterval"
                    slot="activator"
                    color="primary">
                  <v-icon dark>fast_forward</v-icon>
                </v-btn>
                <span style="font-size: 13px">{{this.timeIntervalDescription}}</span>
              </div>

            </v-flex>
          </v-layout>
          <div style="margin: 15px" v-if="this.listReportTracking.length>0 && this.listReportTracking[this.increment]">
            <span style="font-weight: bold">Hora:</span><span>  {{this.formatDateMinus(this.listReportTracking [this.increment].gpsTime)}}</span>
            <br>
            <span style="font-weight: bold">Velocidad:</span><span>  {{(this.listReportTracking [this.increment].speed*1.852).toFixed(2)}} KM/H</span>
            <br>
            <span style="font-weight: bold">Total Recorrido:</span><span>  {{ (this.distance/1000).toFixed(2)}} KM</span>
            <br>
            <span style="font-weight: bold;">Inicio Recorrido:</span><span>  {{this.formatDateMinus(this.listReportTracking[0].gpsTime)}}</span>
            <br>
            <span style="font-weight: bold;"> Fin Recorrido:</span><span> {{this.formatDateMinus(this.listReportTracking[this.listReportTracking.length-1].gpsTime)}}</span>
            <br>
            <span style="font-weight: bold;"> Dirección Inicio:</span><span>
              {{this.directionStart}}</span>
            <br>
            <span style="font-weight: bold;"> Dirección Fin:</span><span>
              {{this.directionEnd}}</span>
            <br>
            <br>
          </div>



        </div>


      </div>
      <div v-if="!searched" style="height: 100%; overflow-y: scroll; padding: 20px">
        <v-layout >
          <v-flex xs12 sm3 offset-sm1>
            <v-menu
                ref="menu"
                :close-on-content-click="false"
                v-model="menu"
                :nudge-right="40"
                :return-value.sync="date"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px">
              <v-text-field
                  slot="activator"
                  v-model="device.start"
                  label="Fecha inicio"
                  prepend-icon="event"
                  readonly
                  :rules="[v => !!v || 'La fecha de inicio es requerida']"
                  required
              ></v-text-field>
              <v-date-picker v-model="device.start"
                             @input="$refs.menu.save(device.start)"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm3>
            <vue-timepicker v-if="device!=''" v-model="device.startTime" format="HH:mm"
                            :rules="[v => !!v || 'La hora de inicio es requerida']"
                            required
            ></vue-timepicker>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 sm3 offset-sm1>
            <v-menu
                ref="menu2"
                :close-on-content-click="false"
                v-model="menu2"
                :nudge-right="40"
                :return-value.sync="date"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px">
              <v-text-field
                  slot="activator"
                  v-model="device.end"
                  label="Fecha fin"
                  prepend-icon="event"
                  readonly
                  :rules="[v => !!v || 'La fecha de fin es requerida']"
                  required
              ></v-text-field>
              <v-date-picker v-model="device.end"
                             @input="$refs.menu2.save(device.end)"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm3>
            <vue-timepicker v-if="device!=''" v-model="device.endTime" format="HH:mm"
                            :rules="[v => !!v || 'La hora de fin es requerida']"
                            required
            ></vue-timepicker>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 sm6 offset-sm4>
            <div>
              <v-btn class="btn-rounded" :disabled="!valid"
                     @click="searchData()" color="primary">Buscar
              </v-btn>
              <v-btn class="btn-rounded"
              @click="searchData('TODAY')" color="primary">Hoy
              </v-btn>
              <v-btn class="btn-rounded"
              @click="searchData('YESTERDAY')" color="primary">Ayer
              </v-btn>
            </div>
          </v-flex>
        </v-layout><br>
        <v-flex xs12 sm6 offset-sm4>
            <div>
              <v-btn class="btn-rounded"
              @click="searchData('THIS WEEK')" color="primary">Esta semana
              </v-btn>
              <v-btn class="btn-rounded"
              @click="searchData('LAST WEEK OF LAST MONTH')" color="primary">Ultima semana mes
              </v-btn>
            </div>
          </v-flex><br>
          <div class="containerdiv">
            <div class="image-container">
              <img :src="this.device.image" alt="" width="80px">
            </div>
            <div class="details-container">
              <div>
                DISPOSITIVO: {{this.device.name}}
              </div>
              <div>
                IMEI: {{this.device.imei}}
              </div>
            </div>
          </div>
          <br>
        <span style="font-weight: bold">Nota: La búsqueda debe ser máximo de una semana en el rango de fecha de inicio y fecha de fin.</span>
        <br>
        <br>
        <br>
        <br>
        <br>
        SIGUENOS
        <br>
              <div class="divButton">
                <a href="https://wa.me/593998704891" target="_blank"><div class="circle"><img src="../../../assets/whatsapp.png" style="width: 80px;"/>
                </div></a>
              </div>
              <div class="divButton">
                <a href="https://www.tiktok.com/@tugpsec" target="_blank"><div class="circle"><img src="../../../assets/tiktok.png" style="width: 80px;"/>
                </div></a>
              </div>
              <div class="divButton">
                <a href="https://www.instagram.com/tugpsec/" target="_blank"><div class="circle"><img src="../../../assets/instagram.png" style="width: 80px;"/>
                </div></a>
              </div>
              <div class="divButton">
                <a href="https://www.facebook.com/TUGPSEC/" target="_blank"><div class="circle"><img src="../../../assets/facebook.png" style="width: 80px;"/>
                </div></a>
              </div>
              <div class="divButton">
                <a href="https://twitter.com/tugpsec" target="_blank"><div class="circle"><img src="../../../assets/twitter.png" style="width: 80px;"/>
                </div></a>
              </div>
            </div>
    </v-form>
  </v-container>
</template>
<script>
import VueTimepicker from 'vue2-timepicker/src'
import $ from "jquery";
const uuid = require('uuid');

export default {
  props: [
    'devices',
    'device',
  ],
  components: {
    VueTimepicker,
  },
  data() {
    return {
      search: '',
      valid: false,
      requiredField: [v => !!v || 'Es requerido'],
      dialog: false,
      dialogInfo: false,
      markers: [],
      editedIndex: -1,
      markerStops: [],
      date: "",
      menu: false,
      menu2: false,
      deviceObject: {id: "", value: "", date: new Date()},
      singleSelect: false,
      active: 0,
      dialogBlock: false,
      dialogError: false,
      dialogGeo: false,
      infoOpened: false,
      infoOptions: null,
      infoPosition: null,
      infoContent: null,
      marker: null,
      windowOpen: false,
      headers2: [
        {text: '#', value: ''},
        {text: 'Nombre del equipo', value: 'name'},
        {text: 'Avatar', value: 'avatar'},
      ],
      mapView: {lat: -0.190029, lng: -78.482114},
      expires_in: 0,
      selectedInMap: "",
      dialogReport: false,
      searched: false,
      reportType: '',
      interval: 0,
      path: [],
      reportData: [],
      increment: 1,
      listReportTracking: [],
      colorLine: '#008000',
      typesReport: ["RUTA", "KILOMETROS"],
      buttonTrack: "PLAY",
      timeInterval: 1500,
      imageDevice: "",
      test:"rotate(50deg)",
      distance:0,
      timeIntervalDescription: "LENTO",
      markerStop: null,
      markerStart: [],
      markerEnd: [],
      directionStart:"",
      directionEnd: "",
      customIconGreen: {
        url: require('../../../assets/green-dot.png'), // Path to your custom icon
        scaledSize: {
          width: 48,
          height: 48
        }
      },
      customIconRed: {
        url: require('../../../assets/red-dot.png'), // Path to your custom icon
        scaledSize: {
          width: 48,
          height: 48
        }
      },
    };
  },
  watch: {
    markers(){
      const self= this
      setTimeout(function(){
        $('img[src*="'+self.imageDevice+'"]').parent().css('transform', 'rotate(' + self.listReportTracking [self.increment].direction + 'deg)');
      }, 5);
    }
  },
  methods: {

    editItem(item) {
      this.editedIndex = this.devices.indexOf(item);
      this.device = Object.assign({}, item);
      this.dialog = true;
    },

    searchData(dayToSearch){
        this.listReportTracking=[]
        this.increment=1
        this.interval= 0,
        this.markerStops=[]
        this.markerStart=[]
        this.markerEnd=[]
        this.reportData=[]
        this.path=[]
        this.mapView={lat:-0.190029, lng:-78.482114},
        this.$store.state.progress = false;
        let dateStart
        let dateEnd
        if(dayToSearch){
            if (dayToSearch === 'TODAY') {
              let currentDate = new Date();
              let year = currentDate.getFullYear();
              let month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
              let day = String(currentDate.getDate()).padStart(2, '0');

              dateStart = `${year}-${month}-${day}T00:00:00Z`;
              dateEnd = `${year}-${month}-${day}T23:59:59Z`;

          } else if (dayToSearch === 'YESTERDAY') {
            let currentDate = new Date();
            currentDate.setDate(currentDate.getDate() - 1); // Subtract 1 day for yesterday

            let year = currentDate.getFullYear();
            let month = String(currentDate.getMonth() + 1).padStart(2, '0');
            let day = String(currentDate.getDate()).padStart(2, '0');

            dateStart = `${year}-${month}-${day}T00:00:00Z`;
            dateEnd = `${year}-${month}-${day}T23:59:59Z`;

          } else if (dayToSearch === 'THIS WEEK') {
              let currentDate = new Date();
              let firstDayOfWeek = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - currentDate.getDay());
              let lastDayOfWeek = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - currentDate.getDay() + 6);

              let firstYear = firstDayOfWeek.getFullYear();
              let firstMonth = String(firstDayOfWeek.getMonth() + 1).padStart(2, '0');
              let firstDay = String(firstDayOfWeek.getDate()).padStart(2, '0');

              let lastYear = lastDayOfWeek.getFullYear();
              let lastMonth = String(lastDayOfWeek.getMonth() + 1).padStart(2, '0');
              let lastDay = String(lastDayOfWeek.getDate()).padStart(2, '0');

              dateStart = `${firstYear}-${firstMonth}-${firstDay}T00:00:00Z`;
              dateEnd = `${lastYear}-${lastMonth}-${lastDay}T23:59:59Z`;

          } else if (dayToSearch === 'LAST WEEK OF LAST MONTH') {
              let currentDate = new Date();
              let lastDayOfPreviousMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);
              let firstDayOfLastWeek = new Date(lastDayOfPreviousMonth.getFullYear(), lastDayOfPreviousMonth.getMonth(), lastDayOfPreviousMonth.getDate() - 6);
              let lastDayOfLastWeek = new Date(lastDayOfPreviousMonth.getFullYear(), lastDayOfPreviousMonth.getMonth(), lastDayOfPreviousMonth.getDate());

              let firstYear = firstDayOfLastWeek.getFullYear();
              let firstMonth = String(firstDayOfLastWeek.getMonth() + 1).padStart(2, '0');
              let firstDay = String(firstDayOfLastWeek.getDate()).padStart(2, '0');

              let lastYear = lastDayOfLastWeek.getFullYear();
              let lastMonth = String(lastDayOfLastWeek.getMonth() + 1).padStart(2, '0');
              let lastDay = String(lastDayOfLastWeek.getDate()).padStart(2, '0');

              dateStart = `${firstYear}-${firstMonth}-${firstDay}T00:00:00Z`;
              dateEnd = `${lastYear}-${lastMonth}-${lastDay}T23:59:59Z`;

          }
        } else {
              dateStart = this.device.start + "T" + this.device.startTime.HH + ":" + this.device.startTime.mm + ":00Z";
              dateEnd = this.device.end + "T" + this.device.endTime.HH + ":" + this.device.endTime.mm + ":00Z";
          }
    
        let queryParam = "deviceId="+this.device.idTraccar+"&from="+dateStart+"&"+"to="+dateEnd
        this.$store.state.progress = true;
        this.$store.dispatch('getDevicesLocationTraccarReport', queryParam).then(response => {
              let firstTimeSearch=true
              if (response.data.result!=null && response.data.result.length > 0) {
                this.$store.dispatch('getDevicesLocationStopsTraccarReport', queryParam).then(response => {
                  this.listStopsTracking = response.data
                  for (const stop of this.listStopsTracking) {
                    let stopPosition = {
                      id: uuid.v4(),
                      position: {
                        lat: stop.latitude,
                        lng: stop.longitude,
                      },
                      icon: {
                        url: 'https://imagenes-tugps.s3.amazonaws.com/stop1.png',
                        scaledSize: {width: 30, height: 30, f: 'px', b: 'px'},
                      },
                      data: stop
                    }
                    this.markerStops.push(stopPosition)
                  }
                  this.$store.dispatch('getDevicesLocationTraccarAlarm', queryParam).then(response => {
                            let listEvents = response.data;
                            let lastIgnitionOffEvent = null;

                            // Sort events by eventTime before processing
                            const sortedEvents = listEvents.sort((a, b) => new Date(a.eventTime) - new Date(b.eventTime));

                            for (const event of sortedEvents) {
                              if (event.type === 'ignitionOff') {
                                // Track the ignitionOff event
                                lastIgnitionOffEvent = event;
                              } else if (event.type === 'ignitionOn' && lastIgnitionOffEvent) {
                                // Capture the current ignitionOff event in a local variable to preserve it
                                const ignitionOffEvent = lastIgnitionOffEvent;

                                // Ensure both events have valid `eventTime`
                                if (ignitionOffEvent.eventTime && event.eventTime) {
                                  const stopPositionId = ignitionOffEvent.positionId; // Use ignitionOff event's positionId

                                  // Fetch location for the ignitionOff position
                                  this.$store.dispatch('getDevicesLocationTraccarReport', "id=" + stopPositionId).then(responseLocation => {
                                    if (responseLocation.data.result[0]) {
                                      let positionStop = responseLocation.data.result[0];

                                      // Parse the event times and ensure time zones are handled
                                      const startTime = new Date(ignitionOffEvent.eventTime).getTime();
                                      const endTime = new Date(event.eventTime).getTime();

                                      // Ensure startTime is before endTime
                                      const correctStartTime = Math.min(startTime, endTime);
                                      const correctEndTime = Math.max(startTime, endTime);

                                      const duration = (correctEndTime - correctStartTime); // Duration in seconds

                                      // Create a marker for the stop with the necessary data
                                      let stopPosition = {
                                        id: uuid.v4(),
                                        position: {
                                          lat: positionStop.lat,
                                          lng: positionStop.lng,
                                        },
                                        icon: {
                                          url: 'https://imagenes-tugps.s3.amazonaws.com/stop1.png',
                                          scaledSize: { width: 30, height: 30 },
                                        },
                                        data: {
                                          startTime: new Date(correctStartTime).toISOString(),
                                          endTime: new Date(correctEndTime).toISOString(),
                                          duration: duration, // Store duration in seconds
                                          latitude: positionStop.lat,
                                          longitude: positionStop.lng
                                        }
                                      };

                                      this.markerStops.push(stopPosition);
                                    }
                                    // Reset lastIgnitionOffEvent after processing
                                    lastIgnitionOffEvent = null;
                                  });
                                } else {
                                  console.error('Missing eventTime for one of the events:', ignitionOffEvent, event);
                                }
                              }
                            }
                          });
                })
                  this.searched = true
                  this.$store.state.progress = false;
                  if (response.data.result != null && response.data.result.length > 0) {
                    this.listReportTracking = response.data.result
                    this.reportData = response.data.result
                    let image = this.device.image
                    if(response.data.result[0].accStatus=='1' && parseInt(response.data.result[0].speed)>0){
                      image = image.replace("1.", "V.");
                    }else if(response.data.result[0].accStatus=='0'){
                      image = image.replace("1.", "R.");
                    }else if(response.data.result[0].accStatus=='1' && response.data.result[0].speed=='0'){
                      image = image.replace("1.", "A.");
                    }else{
                      image = image.replace("1.", "V.");
                    }
                    this.imageDevice = image
                    let respPosition = {
                      position: {
                        lat: this.listReportTracking [this.increment].lat,
                        lng: this.listReportTracking [this.increment].lng,
                      },
                      icon: {
                        url2: this.device.image,
                        url: image,
                        scaledSize: {width: 55, height: 55, f: 'px', b: 'px'},
                        rotation: [45]
                      },
                      markerOptions:{
                        zIndex:999999,
                        opacity:0.5,
                        rotation: 180
                      },
                    }
                    this.mapView = {
                      lat: this.listReportTracking [this.increment].lat,
                      lng: this.listReportTracking [this.increment].lng
                    }
                    this.markers.push(respPosition)
                    for (let i = 0; i <=this.listReportTracking.length ; i++) {
                      if (i == 0) {
                        this.markerStart.push({
                          position: {
                            lat: this.listReportTracking[i].lat,
                            lng: this.listReportTracking[i].lng,
                          },
                          data: { latitude: this.listReportTracking[i].lat, longitude: this.listReportTracking[i].lng, }
                        })
                        this.$store.dispatch('getStreetFromCoordinates', {
                          lat: this.listReportTracking[i].lat,
                          lng: this.listReportTracking[i].lng,
                        }).then(response1 => {
                          this.directionStart = response1
                        })
                      }
                      if (i == this.listReportTracking.length - 1) {
                        this.markerEnd.push({
                          position: {
                            lat: this.listReportTracking[i].lat,
                            lng: this.listReportTracking[i].lng,
                          },
                          data: { latitude: this.listReportTracking[i].lat, longitude: this.listReportTracking[i].lng, }
                        })
                        this.$store.dispatch('getStreetFromCoordinates', {
                          lat: this.listReportTracking[i].lat,
                          lng: this.listReportTracking[i].lng,
                        }).then(response1 => {
                          this.directionEnd = response1
                        })
                      }
                      if(this.listReportTracking [i]!=null){
                        //this.distance = this.distance + parseInt(this.listReportTracking [i].attributes.distance)
                        if ((this.listReportTracking [i].speed*1.852) > this.device.maxSpeed) {
                          this.colorLine = '#ff0000'
                        } else {
                          this.colorLine = '#008000'
                        }
                        this.mapView = {
                          lat: this.listReportTracking [i].lat,
                          lng: this.listReportTracking [i].lng
                        }
                        if(this.listReportTracking [i + 1]!=null){
                          this.path.push({
                            id: uuid.v4(),
                            position: [{
                              lat: this.listReportTracking [i].lat,
                              lng: this.listReportTracking [i].lng
                            }, {
                              lat: this.listReportTracking [i + 1].lat,
                              lng: this.listReportTracking [i + 1].lng
                            }], colorLine: this.colorLine, speed:this.listReportTracking [i].speed
                          })
                        }
                      }
                      if(this.listReportTracking [i]!=null && firstTimeSearch && this.listReportTracking[i].speed==0){
                        this.increment=this.increment+1;
                      }else{
                        firstTimeSearch=false
                      }
                    }
                    this.$store.state.progress = false;
                  } else {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                    this.$store.state.dialogErrorHeader = "Información búsqueda"
                    this.$store.state.dialogErrorMessage = "No se han encontrado datos en la búsqueda realizada"
                  }
              } else {
                this.$store.state.progress = false;
                this.$store.state.dialogError = true;
                this.$store.state.dialogErrorHeader = "Información búsqueda"
                this.$store.state.dialogErrorMessage = "No se han encontrado datos en la búsqueda realizada"
              }
            },
            error => {
              this.$store.state.progress = false;
              this.$store.state.dialogError = true;
            })
      
    },
    createInterval() {
      clearInterval(this.$store.state.intervalReport)
      this.$store.state.intervalReport = setInterval(() => {
        if (this.listReportTracking.length === this.increment) {
          clearInterval(this.$store.state.intervalReport)
        } else {
          this.increment = this.increment + 1;
          this.playTrack()
          this.buttonTrack = "PAUSE"
        }
      }, this.timeInterval);
    },
    stopInterval() {
      clearInterval(this.$store.state.intervalReport)
      this.increment = 1;
      this.buttonTrack = "PLAY"
      this.path = []
      this.markers = []
    },
    pauseInterval() {
      clearInterval(this.$store.state.intervalReport)
      this.buttonTrack = "PLAY"
    },
    changeInterval() {
      clearInterval(this.$store.state.intervalReport)
      if(this.timeInterval==1500){
        this.timeInterval = this.timeInterval - 1000
        this.timeIntervalDescription= "MEDIO"
      }else if(this.timeInterval==500){
        this.timeInterval = this.timeInterval - 200
        this.timeIntervalDescription= "RÁPIDO"
      }else if (this.timeInterval <= 300) {
        this.timeInterval = 1500
        this.timeIntervalDescription= "LENTO"
      }
      this.createInterval()
    },
    playTrack() {
      this.increment++;
      let image = this.device.image
      if(this.listReportTracking [this.increment+1].accStatus=='1' && parseInt(this.listReportTracking [this.increment+1].speed)>0){
        image = image.replace("1.", "V.");
      }else if(this.listReportTracking [this.increment+1].accStatus=='0'){
        image = image.replace("1.", "R.");
      }else if(this.listReportTracking [this.increment+1].accStatus=='1' && this.listReportTracking [this.increment+1].speed=='0'){
        image = image.replace("1.", "A.");
      }else{
        image = image.replace("1.", "V.");
      }
      this.imageDevice = image
      let respPosition = {
        position: {
          lat: this.listReportTracking [this.increment+1].lat,
          lng: this.listReportTracking [this.increment+1].lng,
        },
        icon: {
          url2: this.device.image,
          url: image,
          scaledSize: {width: 55, height: 55, f: 'px', b: 'px'},
          stylers: [{background: 'black', 'visibility': 'off'}]
        },
      }
      if(this.markers[0]==1){
        this.markers[0].position = respPosition
        this.markers[0].icon= {
          url2: this.device.image,
          url: image,
          scaledSize: {width: 55, height: 55, f: 'px', b: 'px'},
          stylers: [{background: 'black', 'visibility': 'off'}]
        }
      }else {
        this.markers = []
        this.markers.push(respPosition)
      }
      this.path=[]
      this.distance = 0
      for (let i = 0; i <=this.increment ; i++) {
        this.distance = this.distance + parseInt(this.listReportTracking[i].attributes.distance)

        if ((this.listReportTracking [i].speed*1.852) > this.device.maxSpeed) {
          this.colorLine = '#ff0000'
        } else {
          this.colorLine = '#008000'
        }
        this.mapView = {
          lat: this.listReportTracking [i].lat,
          lng: this.listReportTracking [i].lng
        }
        if(this.listReportTracking [i + 1]!=null){
          this.path.push({
            position: [{
              lat: this.listReportTracking [i].lat,
              lng: this.listReportTracking [i].lng
            }, {
              lat: this.listReportTracking [i + 1].lat,
              lng: this.listReportTracking [i + 1].lng
            }], colorLine: this.colorLine, speed:this.listReportTracking [i].speed
          })
        }
      }
    },
    formatDate(dateString){
      let date = new Date(dateString);
      var day = date.getDate() + "";
      var month = (date.getMonth() + 1) + "";
      var year = date.getFullYear() + "";
      var hour = (date.getHours());
      var minutes = date.getMinutes() + "";
      var seconds = date.getSeconds() + "";

      day = this.checkZero(day);
      month = this.checkZero(month);
      year = this.checkZero(year);
      hour = this.checkZero(hour);
      minutes = this.checkZero(minutes);
      seconds = this.checkZero(seconds);
      day = this.checkZero(day);
      month = this.checkZero(month);
      year = this.checkZero(year);
      hour = this.checkZero(hour);
      minutes = this.checkZero(minutes);
      seconds = this.checkZero(seconds);

      return year + "-" + month + "-" + day + "T" + hour + ":" + minutes + ":" + seconds+"Z";
    },

    formatDateMinus(dateString) {
      let date = new Date(dateString);
      var day = date.getDate() + "";
      var month = (date.getMonth() + 1) + "";
      var year = date.getFullYear() + "";
      var hour = (date.getHours())
      var minutes = date.getMinutes() + "";
      var seconds = date.getSeconds() + "";
      day = this.checkZero(day);
      month = this.checkZero(month);
      year = this.checkZero(year);
      hour = this.checkZero(hour);
      minutes = this.checkZero(minutes);
      seconds = this.checkZero(seconds);
      day = this.checkZero(day);
      month = this.checkZero(month);
      year = this.checkZero(year);
      hour = this.checkZero(hour);
      minutes = this.checkZero(minutes);
      seconds = this.checkZero(seconds);

      return year + "-" + month + "-" + day + " " + hour + ":" + minutes + ":" + seconds;
    },
    checkZero(data) {
      if (data.length == 1) {
        data = "0" + data;
      }
      return data;
    },

    selectMarker(item) {
      this.markerStop = item
      this.$store.dispatch('getStreetFromCoordinates', {
        lat: this.markerStop.data.latitude,
        lng: this.markerStop.data.longitude,
      }).then(response1 => {
        this.direction = response1
        this.windowOpen = true
      })
    },

  },
  computed: {},
  created() {
    let currentDate = new Date();
    let year = currentDate.getFullYear();
    let month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    let day = String(currentDate.getDate()).padStart(2, '0');

    this.device.start = `${year}-${month}-${day}`;
    this.device.startTime = {HH:'00',mm:'00'};

    this.device.end = `${year}-${month}-${day}`;
    this.device.endTime = {HH:'23',mm:'50'};
  },

};
</script>

<style scoped>
.container {
  max-width: 100% !important;
  padding: 0%;
}

.circle {
  width: 65px;
}

.divButton {
  float:left
}


.containerdiv {
  display: flex;
}
.image-container {
  padding-top: 4px;
  padding-left: 30px;
  width: 50%;
  height: 50px;
}
.details-container {
  margin-top: 20px;
  margin-left: 20px;
  text-align: left;
  width: 50%;
}

</style>



// WEBPACK FOOTER //
// src/components/device/mobile/ReportMobile.vue